"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../components/toolbars/ToolBarButtonsOnly");
var KeyValueItem_1 = require("../../controllers/KeyValueItem");
var WrapTableActions_1 = require("../../components/table_actions/WrapTableActions");
var TableActionSelect_1 = require("../../components/table_actions/TableActionSelect");
var DlgSelectKeyValueItem = /** @class */ (function (_super) {
    __extends(DlgSelectKeyValueItem, _super);
    function DlgSelectKeyValueItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            data: [],
            visible: false,
            title: "",
            columnValueTitle: "Бренд",
            hideToolBarButton: false,
            notAutoCloseDialog: false,
            hideNotAutoCloseDialog: false
        };
        return _this;
    }
    DlgSelectKeyValueItem.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                data: data.data,
                title: data.title,
                columnValueTitle: data.columnValueTitle,
                hideToolBarButton: data.hideReLoadButton,
                notAutoCloseDialog: data.notAutoCloseDialog,
                hideNotAutoCloseDialog: data.hideNotAutoCloseDialog
            });
        });
        this.setState({
            visible: false,
            data: [],
            title: "",
            hideToolBarButton: false,
            notAutoCloseDialog: false,
            hideNotAutoCloseDialog: false
        });
    };
    DlgSelectKeyValueItem.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgSelectKeyValueItem.prototype.getColumns = function () {
        var _this = this;
        return [
            {
                title: this.state.columnValueTitle,
                dataIndex: KeyValueItem_1.i_key_value_item_data_key_value,
                key: KeyValueItem_1.i_key_value_item_data_key_value,
                width: 350
            },
            {
                title: "Действия",
                key: "action",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionSelect_1.default, { hint: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C", onClick: function () {
                            if (_this.props.controller.OnSelect) {
                                _this.props.controller.OnSelect(record.key, record.value);
                            }
                        } }))); },
                align: "center",
                width: 130
            }
        ];
    };
    DlgSelectKeyValueItem.prototype.onToolBarClick = function () {
        if (this.props.controller.onReLoadData) {
            this.props.controller.onReLoadData();
        }
    };
    DlgSelectKeyValueItem.prototype.onCheckBoxChecked = function (checked) {
        var _this = this;
        this.setState({ notAutoCloseDialog: checked }, function () {
            _this.props.controller.SetNotAutoCloseDialog(checked);
        });
    };
    DlgSelectKeyValueItem.prototype.getCheckBox = function () {
        if (this.state.hideNotAutoCloseDialog) {
            return null;
        }
        return (React.createElement("div", { style: { display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
            React.createElement("div", { style: { marginRight: 10, marginLeft: 10 } }, "\u041D\u0435 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u0434\u0438\u0430\u043B\u043E\u0433"),
            React.createElement(antd_1.Switch, { checked: this.state.notAutoCloseDialog, onChange: this.onCheckBoxChecked.bind(this) })));
    };
    DlgSelectKeyValueItem.prototype.getToolBarButton = function () {
        if (this.state.hideToolBarButton) {
            return null;
        }
        else {
            return (React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }, this.getCheckBox()));
        }
    };
    DlgSelectKeyValueItem.prototype.render = function () {
        var _this = this;
        return (React.createElement(antd_1.Modal, { title: this.state.title, visible: this.state.visible, wrapClassName: "vertical-center-modal", closable: true, maskClosable: false, footer: React.createElement("div", null), onCancel: function () {
                if (_this.props.controller.onClose) {
                    _this.props.controller.onClose();
                }
            } },
            React.createElement("div", null,
                this.getToolBarButton(),
                React.createElement(antd_1.Table, { columns: this.getColumns(), dataSource: this.state.data, size: "small", pagination: {
                        pageSize: 10,
                        showSizeChanger: false,
                        position: "bottom",
                        showQuickJumper: false
                    } }))));
    };
    return DlgSelectKeyValueItem;
}(React.Component));
exports.default = DlgSelectKeyValueItem;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgSelectKeyValueItem.tsx
// module id = 2045
// module chunks = 0